module.exports = __webpack_public_path__ + "media/images/area/icon_weather_24-99f5aafeb0db70ae3b31284785c90773.png";